import { Location } from '../builders/location_builder';
import { Datasource, IDatasource, Metasource } from 'utility-ng-kernel';
import { ICampus } from '../../../interfaces/scheduler_interfaces';
import { key } from 'core-ts-types';
import { ICampusesDatasource } from './campuses_datasource';
import * as _4 from 'lodash4';
export interface ILocationsDatasource extends IDatasource<Location> {}

class LocationMeta {
  _campus: ICampus;
  id: key;
}
angular.module('capability-ng-scheduler').factory(
  'ngLocationsDatasource',
  (ngCampusesDatasource: ICampusesDatasource): ILocationsDatasource =>
    new Datasource<Location, LocationMeta>({
      builderType: Location,
      writeMode: 'clobber',
      updateMode: 'merge'
    }).includeMetasource<LocationMeta>((datasource) =>
      new Metasource<Location, LocationMeta>(datasource).includeAttribute('_campus', (location: Location) => {
        return _4.get(ngCampusesDatasource.read(), location.campus);
      })
    )
);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/sections/datasources/locations_datasource.ts